<template>
  <div class="not-found tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-bg-gray-100">
    <h1 class="tw-text-6xl tw-font-bold tw-text-red-500">404</h1>
    <p class="tw-text-xl tw-mt-4 tw-text-gray-700">Oops! Page not found.</p>
    <router-link to="/" class="tw-mt-6 tw-px-4 tw-py-2 tw-bg-blue-500 tw-text-white tw-rounded hover:tw-bg-blue-600">
      Go to Homepage
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
